import { userContext } from 'contexts/UserContext';
import { useBooleanState } from 'hooks/useBooleanState';
import { useContext } from 'react';
import { Modal } from 'antd';
import { DateTime } from 'luxon';
import banner from '../images/kz-ad.jpg';
import styles from './KZAd.module.scss';

const start = DateTime.fromISO('2025-02-27');
const end = DateTime.fromISO('2025-03-16');
const now = DateTime.now();
const isActionAvailable = start <= now && now <= end;
//
export function KZAd() {
  const { user } = useContext(userContext);
  const isKZ = user.Groups.some((g) => g.Country === 'kz');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isShown, _show, hide] = useBooleanState(isKZ && isActionAvailable);

  return (
    (<Modal open={isShown} cancelButtonProps={{ hidden: true }} onOk={hide}>
      <img src={banner} className={styles.image} alt="" />
    </Modal>)
  );
}
